module.exports = __webpack_public_path__ + "img/actionImg3@2x.0fe45ce0.jpg";